import apiService from './apiService';

class FilesD3Service {
  async uploadFile(formData) {
    try {
      const response = await apiService.uploadFileD3(formData);
      return response;
    } catch (error) {
      console.error('Error uploading D3 file:', error);
      throw error;
    }
  }

  async uploadWebUrl(payload) {
    try {
      const response = await apiService.uploadWebUrlD3(payload);
      return response;
    } catch (error) {
      console.error('Error uploading D3 web URL:', error);
      throw error;
    }
  }

  async importGoogleDrive(payload) {
    try {
      const response = await apiService.importGoogleDriveD3(payload);
      return response;
    } catch (error) {
      console.error('Error importing Google Drive files (D3):', error);
      throw error;
    }
  }

  async getFiles(folderId = null) {
    try {
      const response = await apiService.getFilesD3(folderId);
      return response;
    } catch (error) {
      console.error('Error fetching D3 files:', error);
      throw error;
    }
  }

  async getFile(fileId) {
    try {
      const response = await apiService.getFileD3(fileId);
      return response;
    } catch (error) {
      console.error('Error fetching D3 file:', error);
      throw error;
    }
  }

  async updateFileStatus(fileId, status) {
    try {
      const response = await apiService.updateFileStatusD3(fileId, status);
      return response;
    } catch (error) {
      console.error('Error updating D3 file status:', error);
      throw error;
    }
  }

  async deleteFile(fileId) {
    try {
      const response = await apiService.deleteFileD3(fileId);
      return response;
    } catch (error) {
      console.error('Error deleting D3 file:', error);
      throw error;
    }
  }

  async retryFileProcessing(fileId) {
    try {
      const response = await apiService.retryFileProcessingD3(fileId);
      return response;
    } catch (error) {
      console.error('Error retrying D3 file processing:', error);
      throw error;
    }
  }

  async getFilters() {
    try {
      const response = await apiService.getFiltersD3();
      return response;
    } catch (error) {
      console.error('Error fetching D3 filters:', error);
      throw error;
    }
  }

  async getFilter(filterId) {
    try {
      const response = await apiService.getFilterD3(filterId);
      return response;
    } catch (error) {
      console.error('Error fetching D3 filter:', error);
      throw error;
    }
  }

  async createFilter(filterConfig) {
    try {
      const response = await apiService.createFilterD3(filterConfig);
      return response;
    } catch (error) {
      console.error('Error creating D3 filter:', error);
      throw error;
    }
  }

  async updateFilter(filterId, filterConfig) {
    try {
      const response = await apiService.updateFilterD3(filterId, filterConfig);
      return response;
    } catch (error) {
      console.error('Error updating D3 filter:', error);
      throw error;
    }
  }

  async deleteFilter(filterId) {
    try {
      const response = await apiService.deleteFilterD3(filterId);
      return response;
    } catch (error) {
      console.error('Error deleting D3 filter:', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await apiService.getStatsD3();
      return response;
    } catch (error) {
      console.error('Error fetching D3 stats:', error);
      throw error;
    }
  }
}

const filesD3Service = new FilesD3Service();
export default filesD3Service;
